import { render, staticRenderFns } from "./DataQualityDetail.vue?vue&type=template&id=347aa8bd&scoped=true"
import script from "./DataQualityDetail.vue?vue&type=script&lang=js"
export * from "./DataQualityDetail.vue?vue&type=script&lang=js"
import style0 from "./DataQualityDetail.vue?vue&type=style&index=0&id=347aa8bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347aa8bd",
  null
  
)

export default component.exports